import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  backButton: {
    color: theme.palette.text.secondary,
  },
  orderNumber: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  mainCard: {
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  tabContent: {
    padding: theme.spacing(3),
    minHeight: 400,
  },
  boldText: {
    fontWeight: 600,
  },
  sellPrice: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  fulfillmentCard: {
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    border: '1px solid #e0e0e0',
  },
  fulfillmentHeader: {
    marginBottom: theme.spacing(2),
  },
  invoiceCard: {
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    border: '1px solid #e0e0e0',
  },
  invoiceHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  historyTimeline: {
    position: 'relative',
    paddingLeft: theme.spacing(4),
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 11,
      top: 0,
      bottom: 0,
      width: 2,
      backgroundColor: theme.palette.divider,
    },
  },
  historyItem: {
    position: 'relative',
    marginBottom: theme.spacing(3),
  },
  historyDot: {
    position: 'absolute',
    left: -28,
    top: 4,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    border: `3px solid ${theme.palette.background.paper}`,
    boxShadow: '0 0 0 2px ' + theme.palette.primary.main,
  },
  historyContent: {
    paddingLeft: theme.spacing(2),
  },
  historyHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
  },
  sideCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sideCardTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  infoItem: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  profitValue: {
    color: theme.palette.success.main,
    fontWeight: 700,
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  actionButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    borderRadius: 8,
  },
}));
